import { ComponentsOverrides, Theme } from "@mui/material";

import borders from "@/themes/base/borders";
import boxShadows from "@/themes/base/boxShadows";
import colors from "@/themes/base/colors";
import rgba from "@/themes/functions/rgba";

const { black, white } = colors;
const { borderWidth, borderRadius } = borders;
const { md } = boxShadows;

interface ICard {
  styleOverrides: ComponentsOverrides<Theme>["MuiCard"];
}

const card: ICard = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
      borderRadius: borderRadius.xl,
      boxShadow: md,
      overflow: "visible",
    },
  },
};

export default card;
